import { forceUpdate } from "@stencil/core";
export const updateShowcase = () => {
    const showcaseRef = document.querySelector("ch-showcase");
    if (showcaseRef) {
        forceUpdate(showcaseRef);
    }
};
export const insertSpacesAtTheBeginningExceptForTheFirstLine = (text, spaces = 2) => text
    .split("\n")
    .map((line, index) => (index === 0 ? line : " ".repeat(spaces) + line))
    .join("\n");
const identUIModelReact = (uiModel) => insertSpacesAtTheBeginningExceptForTheFirstLine(JSON.stringify(uiModel, undefined, 2));
const identUIModelStencil = (uiModel) => insertSpacesAtTheBeginningExceptForTheFirstLine(JSON.stringify(uiModel, undefined, 2)) + ";";
export const defineControlMarkupWithUIModelReact = (uiModel, uiModelType, renderMarkup) => `import { useState } from "react";
import { ${uiModelType} } from "@genexus/chameleon-controls-library";

const MyCustomDialog = () => {
  const [controlUIModel, setControlUIModel] = useState<${uiModelType}>(${identUIModelReact(uiModel)});

  return (
    <>
      ${renderMarkup}
    </>
  );
}

export default MyCustomDialog;`;
export const defineControlMarkupWithUIModelStencil = (uiModel, uiModelType, renderMarkup) => `import { Component, Host, h } from "@stencil/core";
import { ${uiModelType} } from "@genexus/chameleon-controls-library";

@Component({
  tag: "my-custom-dialog",
  styleUrl: "my-custom-dialog.scss",
  shadow: true
})
export class MyCustomDialog {
  #controlUIModel: ${uiModelType} = ${identUIModelStencil(uiModel)}

  render() {
    return (
      <Host>
        ${renderMarkup}
      </Host>
    );
  }
}`;
export const defineControlMarkupWithoutUIModelReact = (renderMarkup) => `const MyCustomDialog = () => {
  return (
    <>
      ${renderMarkup}
    </>
  );
}

export default MyCustomDialog;`;
export const defineControlMarkupWithoutUIModelStencil = (renderMarkup) => `import { Component, Host, h } from "@stencil/core";

@Component({
  tag: "my-custom-dialog",
  styleUrl: "my-custom-dialog.scss",
  shadow: true
})
export class MyCustomDialog {
  render() {
    return (
      <Host>
        ${renderMarkup}
      </Host>
    );
  }
}`;
export const renderBooleanPropertyOrEmpty = (propertyName, state, spaces = 11) => state[propertyName]
    ? `
${Array(spaces).join(" ")}${propertyName}`
    : "";
const capitalizeFirstLetter = (word) => word[0].toUpperCase() + word.slice(1);
const indentLine = (line, indentation) => `
${Array(indentation).join(" ")}${line}`;
const booleanRender = {
    react: (propertyName, value, defaultValue, indentation) => value === defaultValue
        ? ""
        : indentLine(value ? propertyName : `${propertyName}={${value}}`, indentation),
    stencil: (propertyName, value, defaultValue, indentation) => value === defaultValue
        ? ""
        : indentLine(value ? propertyName : `${propertyName}={${value}}`, indentation)
};
const eventRender = {
    react: (propertyName, value, defaultValue, indentation) => value === defaultValue
        ? ""
        : indentLine(`on${capitalizeFirstLetter(propertyName)}={${value}}`, indentation),
    stencil: (propertyName, value, defaultValue, indentation) => value === defaultValue
        ? ""
        : indentLine(`on${capitalizeFirstLetter(propertyName)}={this.#${value}}`, indentation)
};
const functionRender = {
    react: (propertyName, value, defaultValue, indentation) => value === defaultValue
        ? ""
        : indentLine(`${propertyName}={${value}}`, indentation),
    stencil: (propertyName, value, defaultValue, indentation) => value === defaultValue
        ? ""
        : indentLine(`${propertyName}={this.#${value}}`, indentation)
};
const numberRender = {
    react: (propertyName, value, defaultValue, indentation) => value === defaultValue
        ? ""
        : indentLine(`${propertyName}={${value}}`, indentation),
    stencil: (propertyName, value, defaultValue, indentation) => value === defaultValue
        ? ""
        : indentLine(`${propertyName}={${value}}`, indentation)
};
const stringRender = {
    react: (propertyName, value, defaultValue, indentation) => value === defaultValue
        ? ""
        : indentLine(`${propertyName === "class" ? "className" : propertyName}="${value}"`, indentation),
    stencil: (propertyName, value, defaultValue, indentation) => value === defaultValue
        ? ""
        : indentLine(`${propertyName}="${value}"`, indentation)
};
const stringTemplateRender = {
    react: (propertyName, value, defaultValue, indentation) => value === defaultValue
        ? ""
        : indentLine(`${propertyName}={\`${value}\`}`, indentation),
    stencil: (propertyName, value, defaultValue, indentation) => value === defaultValue
        ? ""
        : indentLine(`${propertyName}={\`${value}\`}`, indentation)
};
const propertyTypeRender = {
    boolean: booleanRender,
    event: eventRender,
    function: functionRender,
    number: numberRender,
    string: stringRender,
    "string-template": stringTemplateRender
};
const defaultIndentationByFramework = (framework) => {
    if (framework === "react") {
        return 9;
    }
    return 11;
};
const renderProperty = (propertyName, state, type, framework, defaultValue, indentation, value) => 
// TODO: Improve type safety
propertyTypeRender[type][framework](propertyName, value ?? state[propertyName], defaultValue, indentation ?? defaultIndentationByFramework(framework));
export const renderShowcaseProperties = (state, framework, properties, indentation) => properties
    .map(propertyInfo => propertyInfo.fixed
    ? renderProperty(propertyInfo.name, state, propertyInfo.type, framework, undefined, indentation, propertyInfo.value)
    : renderProperty(propertyInfo.name, state, propertyInfo.type, framework, propertyInfo.defaultValue, indentation))
    .join("");
export const showcaseTemplateClassProperty = (framework, value) => (framework === "react" ? `className="${value}"` : `class="${value}"`);
